import { createApp } from 'vue'
import Antd from 'ant-design-vue';
import App from './App.vue'
import 'ant-design-vue/dist/reset.css';

// Create app
createApp(App)
  .use(Antd)
  .mount('#app')
